import PropTypes from 'prop-types'
import { Trash } from '@styled-icons/boxicons-solid'
import {
  downloadErrorLogs,
  formatDateTime,
  formatEmptyValue,
} from '../../../../utils/common'
import LinkWithStatus from '../../../common/LinkWithStatus'
import Tooltip from '../../../common/tooltip'
import CheckBox from '../../../common/CheckBox'
import { CapitalHarnessContext, SET_SELECTED_IDS } from './context/context'
import { useContext } from 'react'
import DropDownMenu from '../../../common/DropDownMenu'
import { Menu } from '@styled-icons/boxicons-regular/Menu'

const CapitalHarnessRow = (props) => {
  const [state, dispatch] = useContext(CapitalHarnessContext)

  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-4/12 items-center table_text">
          <div className="px-2">
            <CheckBox
              checked={state?.selectedIds.includes(props.id)}
              onChange={(e) => {
                dispatch({ type: SET_SELECTED_IDS, data: props.id })
              }}
            />
          </div>
          <Tooltip message={props?.name}>
            <div>{formatEmptyValue(props.name)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props?.abbreviation}>
            <div>{formatEmptyValue(props.abbreviation)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          {formatDateTime(props.updated_at)}
        </div>
        <div className="flex w-2/12 pl-6 items-center justify-end">
          {props?.status && (
            <DropDownMenu
              items={[
                props?.status && {
                  name: 'View Details',
                  value: 'show_details',
                },
                {
                  name: 'Copy Circuit Details from',
                  value: 'copy_circuit_details_from',
                },
                {
                  name: 'Copy Devices and Connector Attributes from',
                  value: 'copy_devices_and_connector_attributes_from',
                },
                {
                  name: 'Run File Generation',
                  value: 'run_file_generation',
                },
              ]}
              outsideClickClose={true}
              onClick={(value) => {
                if (value?.value === 'show_details') {
                  props.onShowDetails()
                } else if (value?.value === 'run_file_generation') {
                  props.reRunFileGeneration()
                } else {
                  props.onShowCopyModal(value)
                }
              }}
              width={'30vw'}
            >
              <LinkWithStatus
                href={`/vehicles/capital_harness`}
                className="btn py-1 px-2"
                title="Capital Harneess Button"
                onClickFunc={() => {}}
              >
                <Menu size="1.5rem" color="white" />
              </LinkWithStatus>
            </DropDownMenu>
          )}

          {props?.log?.error?.length > 0 && (
            <div>
              <LinkWithStatus
                href={``}
                className="btn py-1 px-2 mx-2"
                title="Logs"
                onClickFunc={() => {
                  downloadErrorLogs(props?.log?.error, 'error.log')
                }}
              />
            </div>
          )}

          <div>
            <span
              onClick={() => {
                props.onDelete()
              }}
              className="cursor-pointer p-2 px-2"
            >
              <Trash size="2rem" color="#0189E9" />
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

CapitalHarnessRow.propTypes = {
  status: PropTypes.number,
  id: PropTypes.number,
  file_names: PropTypes.object,
  created_at: PropTypes.any,
  onShowDetails: PropTypes.func,
}

export default CapitalHarnessRow
